export default __webpack_public_path__ + "static/real-grad-left-fbe45d07bcc77a9fbb71f7efa340693a.svg";